import { Grid} from '@mui/material';
import React, { useMemo } from 'react';
import { DYNAMIC_QUESTION_ELEMENT } from './constants';
import CustomTextField from './QuestionElement/CustomTextField';
import GroupedElements from './QuestionElement/GroupedElements';
import { QUESTION_TYPE} from '../../_constants/individualFields.constant';

const DynamicQuestionItem = ({ question }) => {
  const {  sizes, questionType, groupItems ,} = question;

  const Element = useMemo(() => DYNAMIC_QUESTION_ELEMENT[questionType] || CustomTextField, [questionType]);

  const ElementWrapper = ({ children, isGroupedElement }) => {
    return (
      <Grid
        container
        spacing={1}
        size={{ xs: 12}}
        justifyContent={(questionType !==  QUESTION_TYPE.CHECKBOX) ? 'flex-end' : ''}
        alignItems="center"
        sx={{ px: 2}}
      >
        {isGroupedElement ? children : 
          <Grid size={sizes||{xs:12}}>
            {children}
          </Grid>} 
      </Grid>
    );
  };

  return (
    <Grid container spacing={1}  sx={{ mb:  2 }} alignItems="center">
      <ElementWrapper isGroupedElement={groupItems?.questions?.length > 0}>
        {!groupItems?.questions?.length && <Element question={question} />}
        {groupItems?.questions?.length > 0 && <GroupedElements questions={groupItems.questions} />}
      </ElementWrapper>
    </Grid>
  )
}

export default DynamicQuestionItem;
